<template>
  <div>
    <div class="cropimage-wrapper">
      <img ref="cropimageRef" :src="imageBase64String" />
    </div>

    <div class="d-flex justify-content-start align-items-center mx-2 my-3">
      <button v-on:click.prevent="finishCropping()" class="btn btn-sm btn-primary ml-2">Färdig</button>
      <button v-on:click.prevent="abortCropping()" class="btn btn-sm btn-secondary ml-2">Avbryt</button>
    </div>
  </div>
</template>
<script setup lang="ts">
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import { onBeforeUnmount, onMounted, ref, toRefs, watch } from "vue";

const props = defineProps({
    imageBase64String: { type: String, default: "" },
    aspectRatio: { type: Number, default: NaN },
});
const { imageBase64String, aspectRatio } = toRefs(props);
const emit = defineEmits(["finishCropping", "abortCropping", "updateCropping"]);
const cropimageRef = ref<HTMLImageElement | null>(null);
const cropper = ref<any>(null);
const cropping = ref({ x: null, y: null, width: null, height: null });

function finishCropping() { emit("finishCropping", cropper.value.getCroppedCanvas().toDataURL()); }
function abortCropping() { emit("abortCropping"); }
function setImage() {
    cropper.value?.destroy();
    if (!cropimageRef.value) { return; }
    cropper.value = new Cropper(cropimageRef.value, {
        aspectRatio: aspectRatio.value,
        viewMode: 2,
        crop: (event) => {
            cropping.value.x = event.detail.x;
            cropping.value.y = event.detail.y;
            cropping.value.width = event.detail.width;
            cropping.value.height = event.detail.height;
        },
    });
}
onMounted(setImage);
onBeforeUnmount(() => cropper.value?.destroy());
watch(imageBase64String, setImage);
watch(aspectRatio, setImage);
watch(cropping, (value) => emit("updateCropping", value), { deep: true });
</script>
<style scoped>
  div.cropimage-wrapper {
    display: inline-block;

    img {
      max-height: 55vh;
      height: 100%;
      width: auto;
    }
  }
</style>
